import { actions } from '@wetransfer/transfer/store/action/apigrants';

export default function (state = {}, action) {
  const { type } = action;

  switch (type) {
    case actions.GET_API_GRANTS:
      return action.details;
    case actions.DELETE_API_GRANT_SUCCESS:
      return state.filter((apiGrant) => apiGrant.id !== action.apiGrantId);
  }

  return state;
}
